module.exports = __webpack_public_path__ + "img/p1_bg.86a66370.jpg";